import PageView from "@/views/Page.vue";
export const repairRouter = {
  path: "/repair",
  redirect: {
    name: "repairManage"
  },
  component: PageView,
  children: [
    {
      path: "add",
      name: "repairAdd",
      component: () => import("@/views/repair/add.vue"),
      meta: {
        title: "报单"
      }
    },
    {
      path: "detail",
      name: "repairDetail",
      component: () => import("@/views/repair/detail.vue"),
      meta: {
        title: "工单详情"
      }
    },
    {
      path: "myList",
      name: "myRepairList",
      component: () => import("@/views/repair/myList.vue"),
      meta: {
        title: "我的报单"
      }
    }
  ]
};
